const MiTurnoIcon = ({ color,clase } ) => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clase}
    >
      <path
        d="M2.25 2.2H3.375V1.1C3.37275 0.3663 3.74625 0 4.5 0C5.25375 0 5.6295 0.3663 5.6295 1.1V2.2H12.375V1.0351C12.375 0.3454 12.7496 0 13.5 0C14.2504 0 14.625 0.3454 14.625 1.0351V2.2H15.75C17.2496 2.2 18 2.9337 18 4.4V19.8C18 21.2663 17.2496 22 15.75 22H2.25C0.750375 22 0 21.2663 0 19.8V4.4044C0 2.9348 0.750375 2.2 2.25 2.2ZM0 6.6V8.8H18V6.6H0ZM5.625 14.3H6.75C7.50037 14.3 7.875 13.9337 7.875 13.2C7.875 12.4663 7.50037 12.1 6.75 12.1H5.62725C4.87687 12.0989 4.50112 12.4652 4.5 13.2C4.5 13.9348 4.87463 14.3011 5.625 14.3ZM11.25 14.3H12.375C13.1254 14.3 13.5 13.9337 13.5 13.2C13.5 12.4663 13.1254 12.1 12.375 12.1H11.2522C10.5019 12.0989 10.1261 12.4652 10.125 13.2C10.125 13.9348 10.4996 14.3011 11.25 14.3ZM5.625 18.7H6.75C7.50037 18.7 7.875 18.3337 7.875 17.6C7.875 16.8663 7.50037 16.5 6.75 16.5H5.62725C4.87687 16.4989 4.50112 16.8652 4.5 17.6C4.5 18.3348 4.87463 18.7011 5.625 18.7ZM11.25 18.7H12.375C13.1254 18.7 13.5 18.3337 13.5 17.6C13.5 16.8663 13.1254 16.5 12.375 16.5H11.2522C10.5019 16.4989 10.1261 16.8652 10.125 17.6C10.125 18.3348 10.4996 18.7011 11.25 18.7Z"
        fill={ color }
      />
    </svg>
  );
};

export default MiTurnoIcon;
